import "core-js"
import "core-js/features/set-immediate";
import "core-js/features/clear-immediate";
import "regenerator-runtime/runtime";
import 'promise-polyfill/src/polyfill';
import '@fluentui/ie11-polyfills';
import { initializeFileTypeIcons } from "@fluentui/react-file-type-icons";
import { initializeIcons, loadTheme } from "@fluentui/react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import "../node_modules/video.js/dist/video-js.min.css";
import "./index.css";
import "./main.scss";
import "./reset.css";
import * as serviceWorker from "./serviceWorker";
import Spintr from "./Spintr";
import configureStore from "./spintr/store";
import Auth from "./auth/Auth";
import { init as initSentry } from "@sentry/react";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string;
const isDevelopment = import.meta.env.DEV;

if (!isDevelopment && typeof sentryDsn === "string" && sentryDsn.length > 0) {
    void initSentry({
        dsn: sentryDsn,
        integrations: [],
        tracesSampleRate: 0.2,
    });
}

if (navigator.platform.match('Mac') !== null) {
    document.body.setAttribute('class', document.body.className + ' MAC');
}

// @ts-ignore
const store = configureStore();

initializeIcons("https://res.cdn.office.net/files/fabric-cdn-prod_20210407.001/assets/icons/");
initializeFileTypeIcons("https://res.cdn.office.net/files/fabric-cdn-prod_20211104.001/assets/item-types/");
loadTheme({});

function ProtectedRoute(props) {
    if (!document.cookie.includes("LoggedIn=true")) {
        const currentPath = window.location.pathname;
        const encodedPath = encodeURIComponent(currentPath);

        return <Redirect to={"/sign-in?return=" + encodedPath} />;
    }

    return props.children;
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    // @ts-ignore Children apparently isn't recognized on BrowserRouter
    <Router>
        <Provider store={store}>
            <Switch>
                <Redirect from="/logga-in" to="/sign-in" />
                <Route path="/sign-in" component={Auth} />
                <Route path="/password-recovery" component={Auth} />
                <Route path="/forgot-password" component={Auth} />
                <ProtectedRoute>
                    <Route path="*" render={props => <Spintr />} />
                </ProtectedRoute>
            </Switch>
        </Provider>
    </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
